const getSortQueryValue = (queryParams, sortItems, initialSortValue) => {
  const sortValue = queryParams.sort;
  if (sortValue && sortValue.split("|").every((v) => sortItems.findIndex((item) => item.key.includes(v)) !== -1)) {
    return sortValue.split("|");
  }
  if (initialSortValue && initialSortValue.every((v) => sortItems.findIndex((item) => item.key.includes(v)) !== -1)) {
    return initialSortValue;
  }
  return [];
};
export {
  getSortQueryValue
};
